import { ChevronRight } from "lucide-react";
import { SlideHeader, Headline, Body, DeepDive, SiteLink } from "../shared";

export function Slide01Problem() {
  const LOOP = ["Sense", "Understand", "Prompt", "Apply", "Learn"];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-problem">
      <SlideHeader n="01" label="Less Friction, More Action" />
      <Headline>
        WearSpray connects personalized intelligence with{" "}
        <span className="text-accent">immediate application.</span>
      </Headline>
      <Body>
        A patented refillable wrist dispenser keeps the user's chosen formulation within reach
        while a developing intelligence layer learns relevant routines, conditions and
        application moments.
      </Body>
      <p className="font-heading text-white text-lg md:text-xl font-medium mt-4 max-w-2xl">
        The missing link between knowing what to do and{" "}
        <span className="text-accent">actually doing it is on the wrist.</span>
      </p>
      <div className="flex flex-wrap items-center gap-x-1.5 gap-y-2.5 mt-6" data-testid="pitch-problem-loop">
        {LOOP.map((w, i) => (
          <div key={w} className="flex items-center gap-1.5">
            <span className="font-mono text-[11px] sm:text-xs tracking-[0.14em] uppercase text-accent border border-accent/40 bg-accent/[0.07] rounded-full px-3.5 py-1.5">
              {w}
            </span>
            {i < LOOP.length - 1 && <ChevronRight size={13} className="text-zinc-600 shrink-0" aria-hidden="true" />}
          </div>
        ))}
      </div>
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-3">
        A preview of the vision, detailed on the following slides.
      </p>
      <div className="mt-5">
        <DeepDive testid="problem" title="The Research Behind It">
          <div className="grid grid-cols-3 gap-4 mt-4">
            {[
              { v: "20\u201360%", c: "#ff2d78", t: "of regular SPF users do not reapply, depending on category" },
              { v: "52.1%", c: "#00e5ff", t: "cite forgetting to bring or apply sunscreen as a barrier" },
              { v: "57%", c: "#e6c068", t: "regret not protecting themselves from the sun in the past" },
            ].map((s) => (
              <div key={s.t}>
                <p className="font-heading text-2xl font-light" style={{ color: s.c }}>{s.v}</p>
                <p className="font-body text-xs text-zinc-400 leading-snug mt-1">{s.t}</p>
              </div>
            ))}
          </div>
          <p className="font-body text-xs text-zinc-500 leading-relaxed mt-6 border-l border-zinc-700 pl-4">
            Research affiliations include Beiersdorf, L'Oréal USA, P&G, Revlon and the Personal Care
            Products Council.
          </p>
          <SiteLink href="https://wearspray.com/science">See the full research on wearspray.com</SiteLink>
        </DeepDive>
      </div>
    </div>
  );
}
